import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ResponsiveDialog } from 'ui';
import { getSelectedSiteCollaborateInfo, setShowTaskCountModal } from '../../../store/siteInfoSlice';

export default function RedirectToDesignModal({ setOpenDesignHubUrl }: { setOpenDesignHubUrl: (value: boolean) => void }) {

  const itemDetails = useSelector(getSelectedSiteCollaborateInfo)
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(function () {
      if (itemDetails?.result.website_design_hub_url) {
        const websiteCareURL = itemDetails?.result.website_design_hub_url
        try {
          window.parent.postMessage({
            type: 'REDIRECT',
            url: websiteCareURL
          }, '*');
        } catch (error) {
          window.location.href = itemDetails?.result.website_design_hub_url;
          console.error('Error redirecting to website care URL:', error);
        }
      }
      setOpenDesignHubUrl(false);
      dispatch(setShowTaskCountModal(false))
    }, 5000);
  }, [itemDetails, setOpenDesignHubUrl, dispatch]);

  return (
    <ResponsiveDialog.Content
      className="text-textcolor isolate max-w-[512px] m-auto my-0 border-none  "
      onInteractOutside={(event: { preventDefault: () => unknown; }) => event.preventDefault()}
      container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
    >
      <div className="w-full flex flex-col items-center justify-center mt-6 rounded-[18px] bg-background">
        <div className="text-left font-normal text-sm ">
          <div>
            <span className='mb-[-20px] font-normal'>
              Redirecting you back to your Website Design Hub...
            </span>
          </div>
        </div>
      </div>
    </ResponsiveDialog.Content >
  );
}
